export const APP_CONST = {
  BASED_URL: process.env.REACT_APP_BACKEND_URL,
  // state Navigation menu
  APP_NAV_MENU: "current_nav_menu",
  NAV_INPUTTER: "nav_inputter",
  NAV_SENDER: "nav_sender",
  NAV_MANAGER: "nav_manager",
  NAV_ADMIN: "nav_admin",
  NAV_AUDITOR: "nav_auditor",
  NAV_AUTHORIZER: "nav_authorizer",
  NAV_REGISTRATION: "nav_registration",
  NAV_RE_INSTALL: "nav_re_install",
  NAV_CUSTOM: "nav_custom",

  // state action
  CURRENT_ACTION: "current_action",
  ACTION_LOGIN: "action_login",
  ACTION_REGISTRATION: "action_registration",
  ACTION_REINSTALL: "action_reinstall",
  // user type
  USER_INFO: "user info",
  USER_ROLES: "user_roles",
  USER_AUTHORITIES: "user_authorities",
  USER_TYPE: "user_type",
  USER_TYPE_INPUTTER: "ROLE_INPUTTER",
  USER_TYPE_SENDER: "ROLE_SENDER",
  USER_TYPE_KEYHOLDER: "ROLE_KEYHOLDER",

  USER_TYPE_MANAGER: "ROLE_MANAGER",
  USER_TYPE_ADMIN: "ROLE_ADMINISTRATOR",
  USER_TYPE_AUDITOR: "ROLE_AUDITOR",
  USER_TYPE_AUTHORIZER: "ROLE_AUTHORIZER",
  // user name
  USERNAME: "user name",
  PARTICIPANT_ID: "participant id",
  // authenthication token
  SEC_TOKEN: "sec_token",
  //  Formating
  DATE_FROM: "YYYY-MM-DD",
  DATE_TO: "YYYY-MM-DD",
  DATETIME_FORMAT: "YYYY-MM-DD HH:mm:ss",
  // Currency format
  RIEL_SYMBOL: "៛",
  USD_SYMBOL: "$",
};

export function getStoredItem(key) {
  return localStorage.getItem(key);
}

export function setStoredItem(key, data) {
  localStorage.setItem(key, data);
}

export function resetStorage() {
  localStorage.clear();
}
